import * as React from "react";
import { AnsweredQuestion } from "@teamprevent/common/model";
import { List } from "semantic-ui-react";

export class QuestionnaireAnswer extends React.Component<{ question: AnsweredQuestion; showQuestion?: boolean }> {
    public render() {
        return (
            <List.Item>
                <List.Content>
                    {this.props.showQuestion && <List.Header as="h4" content={this.props.question.question} />}
                    <List.Description content={this.props.question.answer} />
                </List.Content>
            </List.Item>
        );
    }
}
